export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/shannon-profile-3163b7ce1fdf16c69746377f6de43abc.png";